import { render, staticRenderFns } from "./OfficialPanel.vue?vue&type=template&id=6acfc2cf&"
import script from "./OfficialPanel.vue?vue&type=script&lang=js&"
export * from "./OfficialPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports